import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";

const UndoIcon: React.FC = () => (
    <svg 
        width="14" 
        height="8" 
        viewBox="0 0 14 8" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
    >
        <path 
            d="M1 0.666626V4.66663M1 4.66663H5M1 4.66663L3 2.86663C4.09924 1.88073 5.52341 1.3348 7 1.33329C8.5913 1.33329 10.1174 1.96543 11.2426 3.09065C12.3679 4.21587 13 5.74199 13 7.33329" 
            stroke="#0F172A" 
            strokeWidth="1.33" 
            strokeLinecap="round" 
            strokeLinejoin="round"
        />
    </svg>
);

interface UndoButtonProps {
    className?: string;
    onClick?: any;
    [key: string]: any;
}

export default function UndoButton({
    className,
    onClick,
    ...props
}: UndoButtonProps) {
    const baseClasses = clsx(
        "inline-flex items-center justify-center",
        "h-9 px-2 py-3 gap-2 rounded-md",
        "bg-transparent hover:bg-[#F1F5F9]",
        "text-slate-900 text-sm font-medium leading-5",
        "transition-colors duration-200",
        "font-sans",
        className
    );

    return (
        <button
            className={baseClasses}
            onClick={onClick}
            style={{
                fontFamily: 'Inter, sans-serif',
                fontSize: '14px',
                fontWeight: 500,
                lineHeight: '20px',
                borderRadius: '6px'
            }}
            {...props}
        >
            <UndoIcon />
            <span>Undo</span>
        </button>
    );
}

UndoButton.propTypes = {
    className: PropTypes.string,
    onClick: PropTypes.func,
};
